<template>
  <span>
    <v-row>
      <v-col>
        <v-row align="center" no-gutters>
          <v-col cols="1">
            <v-btn @click="setPaymentType" class="ml-n1" icon>
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="6">
            <span class="d-block caption">
              {{ $t('quote.modal.payWith') }}
            </span>
            <span class="headline">
              {{ paymentTypeLabel}}
            </span>
          </v-col>
          <v-col cols="5" class="text-right">
            <span class="d-block caption">Total</span>
            <span class="headline">
              {{ amount() }}
            </span>
          </v-col>
        </v-row>
        <v-divider class="mt-3 mb-4" />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: 'CheckoutNavigation',

  props: {
    paymentType: {
      type: String,
      required: true,
    },

    planAmount: {
      type: Number,
      required: true,
    },
  },

  computed: {
    paymentTypeLabel() {
      return this.paymentType === 'ASAAS_PIX'
        ? this.$t('quote.modal.pix')
        : this.$t('quote.modal.creditCard')
    },
  },

  methods: {
    setPaymentType() {
      this.$emit('setPaymentType', null)
    },

    amount() {
      const amount = this.planAmount

      if (!amount) return

      const numericAmount = parseFloat(amount)

      if (isNaN(numericAmount)) return

      const formattedAmount = numericAmount.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })

      return formattedAmount
    }
  }
}
</script>
